import { isDefined } from "@opendaw/lib-std";
export var ExportConfiguration;
(function (ExportConfiguration) {
    // The number of STEREO PAIRS a render writes, which sizes `numberOfChannels` (pairs * 2). Without stems a
    // render is a single mixdown pair and the metronome (if any) mixes INTO it rather than adding a pair.
    ExportConfiguration.countStems = (config) => config.match({
        none: () => 1,
        some: cfg => isDefined(cfg.stems)
            ? Object.keys(cfg.stems).length + (isDefined(cfg.metronome?.stem) ? 1 : 0)
            : 1
    });
    // Whether the engine must render the metronome at all for this configuration.
    ExportConfiguration.isMetronomeAudible = (config) => config.match({
        none: () => false,
        some: cfg => isDefined(cfg.stems)
            ? isDefined(cfg.metronome?.stem)
            : cfg.metronome?.includeInMixdown === true
    });
    // The stem file names in CHANNEL ORDER: the unit stems in `stems` key order, then the metronome pair LAST.
    // That is exactly the order the engine stages them in (`set_stem_export` writes the unit records, then
    // `copy_stem_outputs` appends the metronome), and a writer maps channel pair i to name i. Derive the names
    // from HERE rather than re-walking `stems`, which yields one name too few and writes `undefined.wav`.
    ExportConfiguration.stemFileNames = (config) => {
        const names = Object.values(config.stems ?? {}).map(({ fileName }) => fileName);
        const metronomeStem = config.metronome?.stem;
        if (isDefined(metronomeStem)) {
            names.push(metronomeStem.fileName);
        }
        return names;
    };
    ExportConfiguration.sanitizeFileName = (name) => name.replace(/[<>:"/\\|?*\x00-\x1F]/g, "_").trim();
    ExportConfiguration.sanitizeExportNamesInPlace = (configuration) => {
        const metronomeStem = configuration.metronome?.stem;
        if (!isDefined(configuration.stems) && !isDefined(metronomeStem)) {
            return;
        }
        const stems = configuration.stems ?? {};
        const sanitizedNames = new Map();
        const getUniqueName = (baseName) => {
            let count = sanitizedNames.get(baseName) ?? 0;
            let newName = baseName;
            while (sanitizedNames.has(newName)) {
                count++;
                newName = `${baseName} ${count}`;
            }
            sanitizedNames.set(baseName, count);
            sanitizedNames.set(newName, 1);
            return newName;
        };
        Object.keys(stems).forEach((key) => {
            const entry = stems[key];
            entry.fileName = getUniqueName(ExportConfiguration.sanitizeFileName(entry.fileName));
        });
        // The metronome shares the unit stems' namespace (they all land in one zip, where a duplicate name
        // silently overwrites) and is sanitized LAST, matching its channel order, so a collision renames the
        // click rather than a project stem.
        if (isDefined(metronomeStem)) {
            metronomeStem.fileName = getUniqueName(ExportConfiguration.sanitizeFileName(metronomeStem.fileName));
        }
    };
})(ExportConfiguration || (ExportConfiguration = {}));
